module.exports = {"helmetTitle":"Veloe - Alterar senha","title":"Alterar senha","subtitle":"Troque a senha de vez em quando. Mínimo de seis caracteres e máximo de 14 caracteres, pelo menos uma letra e um número são sua segurança.","modalTitle":"Pronto! A gente já salvou sua nova senha. ;)"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ChangePassword/data.json
// module id = 1765
// module chunks = 0